<div class="image-upload">
  <img [src]="image" alt="Avatar" class="img-circle">
  <!-- <img  src="{{profile_settings.files.file_path}}" alt="Avatar" class="img-circle"> -->
  <label for="file-input" *ngIf="!disabled">
    <i class="fa fa-pencil" [matTooltip]="label"></i>
  </label>

  <input id="file-input" type="file" (change)="fileInputChanged($event)" (dragover)="active=1;" (dragleave)="active=0;"
    (drop)="active=0;" accept="image/*" />
</div>